import { STATION } from './const.js';
import { getStore, setStore, removeStore } from './store';
const TokenKey = 'token';
const RefreshTokenKey = 'refresh-token';
export function getUserInfo() {
  const userInfo = getStore({
    name: 'userInfo'
  });

  if (userInfo && userInfo.elsAccount) {
    const elsSubaccountInfoDTO = userInfo.elsSubaccountInfoDTO || {};
    const station = elsSubaccountInfoDTO.station || '';
    const toElsAccountString = elsSubaccountInfoDTO.toElsAccount || '';
    const toElsAccounts = toElsAccountString ? toElsAccountString.split(',') : []; // TODO: 这里假设存在多个 toElsAccount 时, 用字符串形式保存, 不同的 toElsAccount 之间用 "," 分隔

    userInfo.station = station;
    userInfo.toElsAccounts = toElsAccounts;
    return userInfo;
  } else {
    return {
      elsAccount: '307000',
      elsSubAccount: '1001',
      station: STATION.PURCHASE,
      toElsAccounts: []
    };
  }
}
export function getToken() {
  return getStore({
    name: TokenKey
  });
}
export function setToken(token) {
  return setStore({
    name: TokenKey,
    content: token
  });
}
export function getRefreshToken() {
  return getStore({
    name: RefreshTokenKey
  });
}
export function setRefreshToken(token) {
  return setStore({
    name: RefreshTokenKey,
    content: token
  });
}
export function removeToken() {
  return removeStore({
    name: TokenKey
  });
}
export function removeRefreshToken() {
  return removeStore({
    name: RefreshTokenKey
  });
}
const auth = {
  getUserInfo,
  getToken,
  setToken,
  getRefreshToken,
  removeToken,
  removeRefreshToken
};
export default auth;